import setCurrentPage from "src/Utils/setCurrentPage";
import store from "src/Reducers/store";
import Image from "src/Components/Common/Image";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_DS_DEMO_DNA2_1 = {
  title:
    "Meet Tony, a Data Engineer at a large \nTelco, looking for an efficient way to \nspeed up the process of building and \nreviewing pipelines in order to deliver \ninsights for improving customers\n experience.",
  subtitle: "Data STREAMS demo",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(206),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "581px",
            zIndex: 1,
          }}
          imagePath="DNA2/DNA2_demo1_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-79px",
          }}
          imagePath="characters/character_dna2_1.gif"
        />
      </div>
    </div>
  ),
};
